import { Route, Routes as RoutesContainer } from "react-router";
import { Sport, Create, Edit } from "../index";

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/sport' element={<Sport />} />
      <Route exact path='/sport/create' element={<Create />} />
      <Route exact path='/sport/edit/:id' element={<Edit />} />
    </RoutesContainer>
  );
};
export default Routes;
